import {TokenService} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../../shared/language';

export const CreateFileCa = ({header, dataKey, refreshLazyData}) => {
  const {t} = useTranslation();

  const {render, create} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h2>FILE CA</h2>},
      {field: 'files', header: t('common.uploadCertificateFile'), required: true, type: 'file', InputFileProps: {accept: '.p12, .fpx'}, className: 'md:col-12 mb-1'},
      {
        type: 'custom', className: 'md:col-12 mb-4', body: <i>{t('common.validCertificateFileFormat')}</i>
      },
      {field: 'passwordCer', header: t('common.certificatePassword'), type: 'Password', required: true, className: 'md:col-12'}
    ],
    createItem: (item) => {
      const {passwordCer, files} = item;
      const formData = new FormData();
      formData.append('files', files);
      return TokenService.uploadCertificate(passwordCer, formData);
    },
    refreshLazyData
  });

  return {render, open: create};

}
